import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ClearedCheckLayout } from '@app/models/system-settings';

@Injectable()
export class ClearedCheckLayoutService {
	endpointBase = '/api/banks-cf/{bankId}/cleared-check-layout';

	constructor(private readonly http: HttpClient) {}

	getByBankId(bankId: number): Observable<ClearedCheckLayout> {
		return this.http.get<ClearedCheckLayout>(this.endpointBase.replace('{bankId}', bankId.toString()));
	}

	updateForBank(bankId: number, entity: ClearedCheckLayout): Observable<ClearedCheckLayout> {
		return this.http.put<ClearedCheckLayout>(this.endpointBase.replace('{bankId}', bankId.toString()), entity);
	}
}
